(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('LicenseService', [
        'LocalStorageRepository',
        LicenseService,
    ]);

    function LicenseService(
        LocalStorageRepository
    ) {
        return {
            hasFdbDosingLicense: hasFdbDosingLicense,
            hasImoDiagnosisLicense: hasImoDiagnosisLicense,
        };

        function hasFdbDosingLicense() {
            var licenses = LocalStorageRepository.getCurrentUserLicenses();
            return !licenses || //assume has the license since old servers don't send the information
                   licenses.HasFdbDosing;
        }

        function hasImoDiagnosisLicense() {
            var licenses = LocalStorageRepository.getCurrentUserLicenses();
            return !licenses || //assume has the license since old servers don't send the information
                   licenses.HasImoDiagnosis;
        }
    }
})(angular);